import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'

import { TableHelper } from '../../../../tables'

import { ResourceTable } from '../../../../tables/resource-table'

const Resources = observer((props: any) => {
  const { topicID } = props

  const [tableHelper] = useState(
    new TableHelper('list_topic_sources', 'sources', 'topics', topicID),
  )

  return <ResourceTable tableHelper={tableHelper} />
})

export const TopicsResourcesTab = (props: any) => {
  const { id } = props
  return {
    name: 'Sources',
    path: `/content/topics/${id}/sources`,
    component: () => <Resources topicID={id} />,
  }
}
